import styled from 'styled-components';
import { Flex } from 'rebass';
import colors from 'theme/colors';

const Content = styled(Flex)`
  align-items: center;
  justify-content: center;
  margin: 0 10px;
  background: ${colors.white};
  box-shadow: 0px 0px 20px -5px ${colors.darkGray};
`;

export default Content;
